import React, { useState, useEffect } from 'react';
import axios from 'axios';

const UploadCSV = ({ adminMode }) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [data, setData] = useState([]);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setError('');
    setSuccess('');
  };

  const handleUpload = async () => {
    if (!file) {
      setError('Please select a CSV file.');
      return;
    }
    setUploading(true);
    setError('');
    setSuccess('');
    const formData = new FormData();
    formData.append('file', file);
    try {
      const apiBase = process.env.REACT_APP_API_URL || '';
      const uploadUrl = apiBase.endsWith('/') ? apiBase + 'upload-csv' : apiBase + '/upload-csv';
      const response = await axios.post(uploadUrl, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      console.log('Upload response:', response.data);
      setSuccess('File uploaded and data inserted successfully!');
      setTimeout(() => {
        fetchData();
      }, 500);
    } catch (err) {
      console.error('Upload error:', err);
      setError(err.response?.data?.error || 'Upload failed.');
    } finally {
      setUploading(false);
    }
  };

  const fetchData = async () => {
    try {
      const apiBase = process.env.REACT_APP_API_URL || '';
      const csvUrl = apiBase.endsWith('/') ? apiBase + 'csv-data' : apiBase + '/csv-data';
      const res = await axios.get(csvUrl);
      console.log('Fetched data:', res.data);
      setData(res.data);
    } catch (err) {
      console.error('Error fetching data:', err);
      setError('Failed to fetch data.');
    }
  };

  if (adminMode) {
    return (
      <div 
        className="upload-csv-container"
        style={{ 
          width: '100%',
          transform: 'none !important',
          transition: 'none !important'
        }}
      >
        <h2 style={{ 
          textAlign: 'center', 
          marginBottom: '30px',
          color: '#333',
          fontSize: 'clamp(1.5rem, 4vw, 2rem)',
          fontWeight: '600'
        }}>Upload CSV to Database</h2>
        
        <div style={{ 
          marginBottom: '30px',
          padding: '20px',
          backgroundColor: '#f8f9fa',
          borderRadius: '6px',
          border: '1px solid #e9ecef'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
            alignItems: 'flex-start'
          }}>
            <input 
              type="file" 
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" 
              onChange={handleFileChange} 
              style={{ 
                width: '100%',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                backgroundColor: 'white'
              }}
            />
            <button 
              onClick={handleUpload} 
              disabled={uploading}
              className="admin-btn"
              style={{
                backgroundColor: uploading ? '#6c757d' : undefined,
                cursor: uploading ? 'not-allowed' : 'pointer',
                transform: 'none !important',
                transition: 'background-color 0.3s ease',
                width: '100%',
                maxWidth: '200px'
              }}
            >
              {uploading ? 'Uploading...' : 'Upload'}
            </button>
          </div>
        </div>

        {/* Fixed height container for messages to prevent layout shiftt */}
        <div style={{ 
          height: '60px',
          marginBottom: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative'
        }}>
          {error && (
            <p style={{ 
              color: '#dc3545', 
              margin: '0',
              padding: '10px 15px',
              backgroundColor: '#f8d7da',
              border: '1px solid #f5c6cb',
              borderRadius: '4px',
              fontSize: '14px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              whiteSpace: 'nowrap',
              maxWidth: '90%',
              textAlign: 'center'
            }}>
              {error}
            </p>
          )}
          {success && (
            <p style={{ 
              color: '#155724', 
              margin: '0',
              padding: '10px 15px',
              backgroundColor: '#d4edda',
              border: '1px solid #c3e6cb',
              borderRadius: '4px',
              fontSize: '14px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              whiteSpace: 'nowrap',
              maxWidth: '90%',
              textAlign: 'center'
            }}>
              {success}
            </p>
          )}
        </div>

        <div style={{ marginTop: '30px' }}>
          <h3 style={{
            color: '#333',
            marginBottom: '20px',
            fontSize: 'clamp(1.1rem, 3vw, 1.5rem)',
            fontWeight: '600'
          }}>Uploaded Data:</h3>
          <div style={{ 
            overflowX: 'auto',
            border: '1px solid #ddd',
            borderRadius: '6px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            backgroundColor: 'white'
          }} className="admin-table-responsive">
            <table className="admin-table" style={{ 
              width: '100%', 
              borderCollapse: 'collapse',
              backgroundColor: 'white',
              minWidth: '600px'
            }}>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>INVITATION NO</th>
                  <th>NAME OF PARTICIPANTS</th>
                  <th>SUPPLIER NAME</th>
                </tr>
              </thead>
              <tbody>
                {data.length === 0 ? (
                  <tr>
                    <td colSpan="4" style={{
                      textAlign: 'center',
                      padding: '40px',
                      color: '#6c757d',
                      fontSize: '16px'
                    }}>
                      {uploading ? 'Loading data...' : 'No data available'}
                    </td>
                  </tr>
                ) : (
                  data.map((row, index) => (
                    <tr key={row.id}>
                      <td>{row.id}</td>
                      <td>{row['INVITATION NO']}</td>
                      <td>{row['NAME  OF PARTICIPANTS']}</td>
                      <td>{row['SUPPLIER NAME']}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ 
      padding: '20px',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '30px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ 
          textAlign: 'center', 
          marginBottom: '30px',
          color: '#333',
          fontSize: '28px',
          fontWeight: '600'
        }}>Upload CSV to Database</h2>
        
        <div style={{ 
          marginBottom: '30px',
          padding: '20px',
          backgroundColor: '#f8f9fa',
          borderRadius: '6px',
          border: '1px solid #e9ecef'
        }}>
          <input 
            type="file" 
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" 
            onChange={handleFileChange} 
            style={{ 
              marginRight: '15px',
              padding: '8px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              backgroundColor: 'white'
            }}
          />
          <button 
            onClick={handleUpload} 
            disabled={uploading}
            style={{
              padding: '10px 25px',
              backgroundColor: uploading ? '#6c757d' : '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: uploading ? 'not-allowed' : 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              if (!uploading) {
                e.target.style.backgroundColor = '#0056b3';
                e.target.style.transform = 'translateY(-1px)';
              }
            }}
            onMouseOut={(e) => {
              if (!uploading) {
                e.target.style.backgroundColor = '#007bff';
                e.target.style.transform = 'translateY(0)';
              }
            }}
          >
            {uploading ? 'Uploading...' : 'Upload'}
          </button>
        </div>

        {/* Fixed height container for messages to prevent layout shift */}
        <div style={{ 
          height: '60px',
          marginBottom: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative'
        }}>
          {error && (
            <p style={{ 
              color: '#dc3545', 
              margin: '0',
              padding: '10px 15px',
              backgroundColor: '#f8d7da',
              border: '1px solid #f5c6cb',
              borderRadius: '4px',
              fontSize: '14px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              whiteSpace: 'nowrap'
            }}>
              {error}
            </p>
          )}
          {success && (
            <p style={{ 
              color: '#155724', 
              margin: '0',
              padding: '10px 15px',
              backgroundColor: '#d4edda',
              border: '1px solid #c3e6cb',
              borderRadius: '4px',
              fontSize: '14px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              whiteSpace: 'nowrap'
            }}>
              {success}
            </p>
          )}
        </div>

        {/* Fixed container for table to prevent layout shift */}
        <div style={{ 
          marginTop: '30px',
          minHeight: '400px',
          position: 'relative'
        }}>
          <h3 style={{
            color: '#333',
            marginBottom: '20px',
            fontSize: '20px',
            fontWeight: '600',
            position: 'sticky',
            top: '0',
            backgroundColor: 'white',
            zIndex: 10,
            padding: '10px 0'
          }}>Uploaded Data:</h3>
          <div style={{ 
            overflowX: 'auto',
            border: '1px solid #ddd',
            borderRadius: '6px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            minHeight: '300px',
            backgroundColor: 'white'
          }}>
            <table style={{ 
              width: '100%', 
              borderCollapse: 'collapse',
              backgroundColor: 'white'
            }}>
              <thead>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <th style={{ 
                    border: '1px solid #dee2e6', 
                    padding: '12px 8px', 
                    textAlign: 'left',
                    fontWeight: '600',
                    color: '#495057',
                    fontSize: '14px'
                  }}>ID</th>
                  <th style={{ 
                    border: '1px solid #dee2e6', 
                    padding: '12px 8px', 
                    textAlign: 'left',
                    fontWeight: '600',
                    color: '#495057',
                    fontSize: '14px'
                  }}>INVITATION NO</th>
                  <th style={{ 
                    border: '1px solid #dee2e6', 
                    padding: '12px 8px', 
                    textAlign: 'left',
                    fontWeight: '600',
                    color: '#495057',
                    fontSize: '14px'
                  }}>NAME OF PARTICIPANTS</th>
                  <th style={{ 
                    border: '1px solid #dee2e6', 
                    padding: '12px 8px', 
                    textAlign: 'left',
                    fontWeight: '600',
                    color: '#495057',
                    fontSize: '14px'
                  }}>SUPPLIER NAME</th>
                </tr>
              </thead>
              <tbody>
                {data.length === 0 ? (
                  <tr>
                    <td colSpan="4" style={{
                      textAlign: 'center',
                      padding: '40px',
                      color: '#6c757d',
                      fontSize: '16px',
                      border: '1px solid #dee2e6'
                    }}>
                      {uploading ? 'Loading data...' : 'No data available'}
                    </td>
                  </tr>
                ) : (
                  data.map((row, index) => (
                    <tr key={row.id} style={{
                      backgroundColor: index % 2 === 0 ? 'white' : '#f8f9fa'
                    }}>
                      <td style={{ 
                        border: '1px solid #dee2e6', 
                        padding: '10px 8px',
                        fontSize: '14px'
                      }}>{row.id}</td>
                      <td style={{ 
                        border: '1px solid #dee2e6', 
                        padding: '10px 8px',
                        fontSize: '14px'
                      }}>{row['INVITATION NO']}</td>
                      <td style={{ 
                        border: '1px solid #dee2e6', 
                        padding: '10px 8px',
                        fontSize: '14px'
                      }}>{row['NAME  OF PARTICIPANTS']}</td>
                      <td style={{ 
                        border: '1px solid #dee2e6', 
                        padding: '10px 8px',
                        fontSize: '14px'
                      }}>{row['SUPPLIER NAME']}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadCSV; 